import { stringify } from 'qs';
import request, { format } from '@/utils/request';

export async function ssoLogout() {
  request('/sso/logout');
}

export function fetchSameLevelTest() {
  return format(
    request('/mdc/experiment/abTest?experiment=SGC_SameLevelTest&experimentType=1', {
      method: 'GET',
    })
  );
}

export function fetchGrayTest(grayExperiment = 'sgc_gray_root_experiment') {
  return format(
    request(`/mdc/common/grayTest?grayExperiment=${grayExperiment}`, {
      method: 'GET',
    })
  );
}

export function fetchAIConfig(payload) {
  return format(
    request('/mdc/ai/config', {
      method: 'POST',
      body: payload,
    })
  );
}

// 检查服务范围报错是否超出当前城市范围
export async function checkServiceArea(payload = {}, errorHandler) {
  return format(
    request('/mdc/service/report/checkArea', {
      method: 'POST',
      body: {
        ...payload,
      },
    }),
    errorHandler
  );
}

// 获取上门服务初始化默认值
export async function fetchServiceConfigs(payload = {}) {
  const params = stringify(payload);
  return format(request(`/mdc/service/report/config?${params}`));
}

export async function fetchServiceFormValidate(payload = {}) {
  return format(
    request('/mdc/service/report/preCheck', {
      method: 'POST',
      body: payload,
    }),
    null,
    { returnAllRes: true }
  );
}

export async function fetchRegionBoundary(payload = {}) {
  return format(
    request('/mdc/service/report/regionBoundary', {
      method: 'POST',
      body: payload,
    })
  );
}

export async function fetchDistrictRegions({ cityId, ...rest }) {
  const params = stringify(rest);
  return format(request(`/geo/china/cities/${cityId}/districtRegions?${params}`));
}

// 上门服务报错提交
export async function submitServiceReport(payload = {}) {
  return format(
    request('/mdc/service/report/submit', {
      method: 'POST',
      body: {
        ...payload,
      },
    }),
    null,
    { returnAllRes: true }
  );
}

// 营业时间jsonToTxt
export async function bizTimeJsonToTxt(payload = {}) {
  return format(
    request('/mdc/base/bizTime/json2Txt', {
      method: 'POST',
      body: payload,
    }),
    () => {}
  );
}

// 城市边界
export async function fetchCityBoundary(payload = {}) {
  const params = stringify(payload);
  return format(request(`/mdc/service/report/cityBoundary?${params}`));
}

export async function searchPoiById(payload = {}) {
  const params = stringify(payload);
  return format(request(`/mdc/shop/report/info?${params}`));
}

export async function searchPoiByName(payload = {}, errorHandler = null) {
  const params = stringify(payload);
  return format(request(`/mdc/search/shop?${params}`), errorHandler);
}

export function searchRelatedShopByName(payload = {}, errorHandler = null) {
  if (!payload.keyword) return null;
  return format(
    request('/mdc/search/outerShop', {
      method: 'POST',
      body: payload,
    }),
    errorHandler
  );
}

export async function searchPoiByIds(payload = {}, errorHandler = null) {
  return format(
    request('/mdc/search/page/shop', {
      method: 'POST',
      body: payload,
    }),
    errorHandler
  );
}

export async function fetchFakeStrategyTag(payload = {}, errorHandler = null) {
  const { shopId, source } = payload;
  const params = `?shopId=${shopId}&source=${source}`;
  return format(request(`/mdc/shop/report/fakeStrategyTag${params}`), errorHandler);
}

export async function fetchProvinces(payload = {}) {
  const { source } = payload;
  const params = source ? `?source=${source}` : '';
  return format(request(`/geo/china/provinces${params}`));
}

export async function fetchCities(payload = {}) {
  const { source, provinceId } = payload;
  const params = source ? `?source=${source}` : '';
  return format(request(`/geo/china/provinces/${provinceId}/cities${params}`));
}

export async function fetchDistricts(payload = {}) {
  const { source, cityId } = payload;
  const params = source ? `?source=${source}` : '';
  return format(request(`/geo/china/cities/${cityId}/districts${params}`));
}

export async function fetchRegions(payload = {}) {
  const { source, districtId } = payload;
  const params = source ? `?source=${source}` : '';
  return format(request(`/geo/china/districts/${districtId}/regions${params}`));
}

/*
  source: 美团or点评侧
  return: 城市对应的所有行政区和商圈
*/
export async function fetchDistrictsRegions(payload = {}) {
  const { shopId, source, longitude, latitude } = payload;
  const params = `?shopId=${shopId}&source=${source}&longitude=${longitude}&latitude=${latitude}`;
  return format(request(`/mdc/base/gis/regionList${params}`));
}

export async function fetchBackCates(payload = {}) {
  payload.type = payload.type ?? '';
  const params = stringify(payload);
  return format(request(`/mdc/backcates?${params}`));
}

export async function fetchFrontCates(payload = {}) {
  const { cityId, backCateId } = payload;
  return format(request(`/frontcates?cityId=${cityId}&backCateId=${backCateId}`));
}

export async function fetchAddressByCoordinates(payload = {}) {
  const { latitude, longitude } = payload;
  return format(request(`/geo/china/addresses?lat=${Number(latitude)}&lng=${Number(longitude)}`));
}

export function fetchTrialTime(payload) {
  const { dpShopId } = payload;
  return format(request(`/mdc/trialOperation/queryTime?dpShopId=${dpShopId}`));
}

export function fetchCloseReasonEnum(payload) {
  return format(request('/mdc/shop/report/getPowerConfig'));
}

// 通过类别判断，返回停业原因选项
export function fetchCloseReasonEnumByCategory(payload) {
  const { categoryId } = payload;
  return format(request(`/mdc/shop/report/getCategoryPowerConfig?categoryId=${categoryId}`));
}

export function fetchTrialTimeRange(payload) {
  const { dpShopId, containTrail } = payload;
  return format(
    request(`/mdc/trialOperation/queryTimeRange?dpShopId=${dpShopId}&containTrail=${containTrail}`)
  );
}

export function submitTrialTime(payload, errorHandler = () => {}) {
  return format(
    request('/mdc/trialOperation/submitTime', {
      method: 'POST',
      body: payload,
    }),
    errorHandler,
    { returnAllRes: true }
  );
}

export function submitFuzzyTime(payload, errorHandler = () => {}) {
  return format(
    request('/mdc/trialOperation/submitFuzzyTime', {
      method: 'POST',
      body: payload,
    }),
    errorHandler,
    { returnAllRes: true }
  );
}

export async function batchSubmitPoiInfo(args = {}, errorHandler = null) {
  return format(
    request('/mdc/shop/report/batchSubmit', {
      method: 'POST',
      body: args,
      __SCENE_INFO__: true,
    }),
    errorHandler,
    { returnAllRes: true }
  );
}

// 批量提报特殊营业时间-春节不打烊
export async function batchSubmitPoiInfoWithFestival(args = {}, errorHandler = null) {
  return format(
    request('/mdc/shop/batch/submit', {
      method: 'POST',
      body: args,
      __SCENE_INFO__: true,
    }),
    errorHandler,
    { returnAllRes: true }
  );
}

export async function preCheckPoiInfo(args = {}) {
  const { _clientType_, ...payload } = args;
  const newParams = payload.params || payload || {};

  // 营业时间从json变成string
  if (newParams.businessHoursObj) {
    newParams.businessHours = JSON.stringify(newParams.businessHoursObj);
    delete newParams.businessHoursObj;
  }
  newParams.bizType = 3;
  return preCheck(newParams);
}

export async function submitPoiInfo(args = {}) {
  const { _clientType_, ...payload } = args;
  const newParams = payload.params || payload || {};

  // 营业时间从json变成string
  if (newParams.businessHoursObj) {
    newParams.businessHours = JSON.stringify(newParams.businessHoursObj);
    delete newParams.businessHoursObj;
  }
  return format(
    request(`/${_clientType_ || 'mdc'}/shop/report/submit`, {
      method: 'POST',
      body: newParams,
      __SCENE_INFO__: true,
    }),
    null,
    { returnAllRes: true }
  );
}

export async function fetchMyRecords(payload = {}) {
  const params = stringify(payload);
  return format(request(`/records?${params}`));
}
// 基本信息报错
export async function fetchMyNewRecords(payload = {}) {
  const params = stringify(payload);
  return format(request(`/mdc/record/list?${params}`));
}

export async function fetchShopNameRule(payload = {}) {
  const params = stringify(payload);
  return format(request(`/mdc/shop/report/reportLogSearch?${params}`));
}

// 获取虚假商户提示文案
export async function fetchFakeShopConfigs(payload = {}) {
  const params = stringify(payload);
  return format(request(`/mdc/shop/report/config?${params}`));
}

export async function fetchQualificationStructure(
  { method = 'POST', ...payload },
  sub = 'shopAdd',
  errorHandler = () => {}
) {
  if (method === 'GET') {
    const params = stringify(payload);
    return format(request(`/mdc/shop/qualification/structure/${sub}?${params}`));
  } else {
    return format(
      request(`/mdc/shop/qualification/structure/${sub}`, {
        method: 'POST',
        body: payload,
      }),
      errorHandler
    );
  }
}

// 其他报错-查看详情-审核日志
export async function fetchRecordAudit(payload = {}) {
  const { flowId, flowType } = payload;
  const params = stringify({ flowType });
  return format(request(`/mdc/listing/${flowId}?${params}`), () => {});
}
// 基本信息报错-查看详情
export async function fetchBasicRecordDetail(payload = {}, errorHandler) {
  const params = stringify(payload);
  return format(request(`/mdc/record/detail?${params}`), errorHandler);
}
// 我的待办
export async function fetchMyTodoDetail(payload = {}) {
  const params = stringify(payload);
  return format(request(`/mdc/auditTask/detail?${params}`));
}

export async function fetchMyTodo(payload = {}) {
  const params = stringify(payload);
  return format(request(`/mdc/auditTask/list?${params}`));
}
// 我的新增
export async function fetchMyNewShops(payload = {}, errorHandler) {
  const params = stringify(payload);
  return format(request(`/mdc/record/list?${params}`), errorHandler, {
    returnAllRes: true,
  });
}
// 新增页撤销功能
// 撤销前 preCheck
export async function cancelPreCheck(payload = {}, errorHandler) {
  return format(
    request('/mdc/shopAdd/cancel/preCheck', {
      method: 'POST',
      body: {
        ...payload,
      },
    }),
    errorHandler,
    { unwrap: true }
  );
}
// 撤销 cancel
export async function cancelShopAdd(payload = {}, errorHandler) {
  return format(
    request('/mdc/shopAdd/cancel', {
      method: 'POST',
      body: {
        ...payload,
      },
    }),
    errorHandler,
    { unwrap: true }
  );
}
// 基本信息-提交申诉
export async function submitNewAppealInfo(payload = {}, errorHandler) {
  return format(
    request('/mdc/record/submitAppeal', {
      method: 'POST',
      body: {
        ...payload,
      },
      __SCENE_INFO__: true,
    }),
    errorHandler
  );
}
// 提交申诉
export async function submitAppealInfo(payload = {}, errorHandler) {
  return format(
    request('/appeals', {
      method: 'POST',
      body: {
        ...payload,
      },
    }),
    errorHandler
  );
}
// 通用 POST 请求函数
const createSubmitFunction = (url, options = {}) => {
  return async (payload = {}, errorHandler) => {
    const { body } = payload;
    return format(
      request(url, {
        method: 'POST',
        body,
      }),
      errorHandler,
      options
    );
  };
};

// 提交 通知类待办
export const submitNotice = createSubmitFunction('/mdc/auditTask/submitDone');
// 提交 通知类待办四合一
export const submitTodo = createSubmitFunction('/mdc/auditTask/submit', { returnAllRes: true });
// 无需下线并说明
export const submitAccept = createSubmitFunction('/mdc/auditTask/submitAccept', {
  returnAllRes: true,
});
// 确认下线
export const submitRefuse = createSubmitFunction('/mdc/auditTask/submitRefuse', {
  returnAllRes: true,
});
// 提交 仲裁、举证
export const submitAuditInfo = createSubmitFunction('/mdc/auditTask/submitAccept');
// 获取父子关系 父商户的类型列表
export async function fetchParentAllTypes(payload = {}) {
  return format(request('/paternity/getAllTypes'));
}
export async function fetchParentById(payload = {}) {
  const params = stringify(payload);
  return format(request(`/paternity/getById?${params}`));
}

export async function fetchParentPartitions(payload = {}) {
  const params = stringify(payload);
  return format(request(`/mdc/paternity/searchPartitions?${params}`));
}
export async function fetchParentShopList(payload = {}, errorHandler) {
  const params = stringify(payload);
  return format(request(`/mdc/paternity/searchParents?${params}`), errorHandler);
}
export async function submitParentInfo(payload = {}) {
  return format(
    request('/mdc/paternity/submitParents', {
      method: 'POST',
      body: payload,
    }),
    null,
    { returnAllRes: true }
  );
}
export async function submitParentInfoV2(payload = {}) {
  return format(
    request('/mdc/paternity/submitParentsV2', {
      method: 'POST',
      body: payload,
    }),
    null,
    { returnAllRes: true }
  );
}

// 查询文件上传进度
export async function getUploadFileProgress(payload = {}) {
  return format(
    request('/mdc/base/file/progress', {
      method: 'POST',
      body: {
        ...payload,
      },
    })
  );
}

// 获取批量品牌门店报错列表
export async function getBrandShopListRecords(payload, errorHandler) {
  const params = stringify(payload);
  console.log('baocuo', params);
  return format(request(`/mdc/shop/batch/records?${params}`), errorHandler);
}

// 分页获取异常门店
export async function getAbnornalShopListRecords(payload, errorHandler) {
  const params = stringify(payload);
  return format(request(`/mdc/shop/manage/task/pageSearch?${params}`), errorHandler);
}
// 获取异常门店的品牌、门店区域的下拉框选项数据
export async function getAbnornalShopSearchConditions(payload, errorHandler) {
  return format(request('/mdc/shop/manage/task/searchConditions'), errorHandler);
}

// 测试环境缓存数据写入
export async function fetchSetKvInTest(payload = {}, errorHandler) {
  console.log('缓存数据写入', payload);
  return format(
    request('https://m.51ping.com/poi/contr/common/kvPut', {
      method: 'POST',
      body: payload,
    }),
    errorHandler
  );
}

// 测试环境缓存数据查询
export async function fetchGetKvInTest(payload, errorHandler) {
  const params = stringify(payload);
  return format(request(`https://m.51ping.com/poi/contr/common/kvGet?${params}`), errorHandler);
}

// 线上缓存数据写入
export async function fetchSetKv(payload = {}, errorHandler) {
  console.log('缓存数据写入', payload);
  return format(
    request('https://m.dianping.com/poi/contr/common/kvPut', {
      method: 'POST',
      body: payload,
    }),
    errorHandler
  );
}

// 线上缓存数据查询
export async function fetchGetKv(payload, errorHandler) {
  const params = stringify(payload);
  return format(request(`https://m.dianping.com/poi/contr/common/kvGet?${params}`), errorHandler);
}

// 保存草稿
export async function saveDraft(payload, errorHandler) {
  return format(
    request('/mdc/shop/manage/task/saveDraft', {
      method: 'POST',
      body: payload,
    }),
    errorHandler,
    { returnAllRes: true }
  );
}

// 下载批量品牌门店提报记录明细
export async function getBrandShopListDetail(payload) {
  return format(request(`/mdc/shop/batch/records/${payload.batchId}/details`));
}

// 提交批量品牌门店报错信息
export async function submitBrandShopListFile(payload, errorHandler) {
  return format(
    request('/mdc/shop/batch/submit', {
      method: 'POST',
      body: payload,
    }),
    null,
    { returnAllRes: true }
  );
}

// 提交批量举报虚假商户的文件
export async function submitMultiFakeInfo(payload = {}) {
  return format(
    request('/mdc/fakePoi/submitBatch', {
      method: 'POST',
      body: {
        ...payload,
      },
    }),
    null,
    { returnAllRes: true }
  );
}

// 获取批量举报虚假商户的列表
export async function getMultiFakeInfoList(payload = {}) {
  const params = stringify(payload);
  return format(request(`/mdc/fakePoi/batch?${params}`));
}

// 婚宴副本报错提交
export async function submitWeddingInfo(payload = {}) {
  const { type, method, params } = payload;
  return format(
    request(`/mdc/wedding/${type}`, {
      method: `${method}`,
      body: params,
    }),
    null,
    { returnAllRes: true }
  );
}
export async function searchWeddingShop(payload = {}, errorHandler) {
  const params = stringify(payload.params);
  return format(
    request(`/mdc/wedding/getRelation?${params}`, {
      method: 'GET',
    }),
    null,
    { returnAllRes: true }
  );
}

export async function fetchRelatedShops(payload = {}, errorHandler = () => void 0) {
  const params = stringify(payload);
  return format(request(`/mdc/relation/relatedShops?${params}`), errorHandler);
}

// 门店重复相关报错：
export async function fetchShopRelations(payload = {}) {
  const params = stringify(payload);
  return format(request(`/mdc/relation/group?${params}`));
}
// 路引信息相关：
export async function fetchGetGuideList(payload = {}) {
  const { id } = payload;
  const params = stringify(payload.params);
  return format(request(`/mdc/roads/guides?${params}`));
}
export async function fetchGetGuideRoads(payload = {}) {
  const shopId = stringify(payload);
  return format(request(`/mdc/roads/info?${shopId}`));
}
export async function fetchGetSubwayEntry(payload = {}) {
  const params = stringify(payload);
  return format(request(`/mdc/roads/metras?${params}`));
}
export async function submitGuide(payload = {}) {
  return format(
    request('/mdc/roads/submit', {
      method: 'POST',
      body: {
        ...payload,
      },
    }),
    null,
    { returnAllRes: true }
  );
}
// 后端 merge 代表选主，与前端路由名不一致！
export async function submitRelationsMain(payload = {}) {
  return format(
    request('/relations/merges', {
      method: 'POST',
      body: {
        ...payload,
      },
    })
  );
}
export async function submitRelationsMerges(args = {}) {
  const { _clientType_, ...payload } = args;
  return format(
    request(`/${_clientType_ || 'mdc'}/relation/merge`, {
      method: 'POST',
      body: {
        ...payload,
      },
      __SCENE_INFO__: true,
    }),
    null,
    { returnAllRes: true }
  );
}
export async function submitRelationsSplits(payload = {}) {
  return format(
    request('/mdc/relation/split', {
      method: 'POST',
      body: {
        ...payload,
      },
      __SCENE_INFO__: true,
    }),
    null,
    { returnAllRes: true }
  );
}

export async function submitRelationsUpdate(payload = {}) {
  return format(
    request('/mdc/relation/submit', {
      method: 'POST',
      body: {
        ...payload,
      },
      __SCENE_INFO__: true,
    }),
    null,
    { returnAllRes: true }
  );
}

// 查询连锁关系
export async function fetchGroupShop(payload = {}) {
  const params = stringify(payload);
  return format(request(`/mdc/groups?${params}`));
}

// 解除连锁关系
export async function submitRemoveGroup(payload = {}) {
  return format(
    request('/mdc/groups/deletes', {
      method: 'POST',
      body: {
        ...payload,
      },
    }),
    null,
    { returnAllRes: true }
  );
}
export async function submitAddGroups(payload = {}) {
  return format(
    request('/mdc/groups/add', {
      method: 'POST',
      body: {
        ...payload,
      },
    }),
    null,
    { returnAllRes: true }
  );
}

// 门店资质搜索
export async function searchQualificationUrlById(payload = {}) {
  const { id, source } = payload;
  const params = source ? `?shopId=${id}&source=${source}` : '';
  return format(request(`/mdc/certificates${params}`));
}

// 资质提交
export async function submitQualification(payload = {}, errorHandler) {
  return format(
    request('/mdc/certificates/submit', {
      method: 'POST',
      body: {
        ...payload,
      },
    }),
    errorHandler
  );
}

export async function fetchMyGroups(payload = {}) {
  const params = stringify(payload);
  return format(request(`/records?${params}`));
}

export async function preCheck(params) {
  const { bizType, ...payload } = params;
  return format(
    request('/mdc/preCheck', {
      method: 'POST',
      body: {
        bizType,
        payload: JSON.stringify(payload),
      },
    }),
    null,
    { returnAllRes: true }
  );
}

// 新增门店
export async function submitNewShop(payload = {}) {
  return format(
    request('/mdc/shopAdd/submit', {
      method: 'POST',
      body: {
        ...payload,
      },
    }),
    null,
    { returnAllRes: true }
  );
}

// 根据用户查询用户负责品牌列表
export async function fetchUserBrandList(payload = {}, errorHandler) {
  // 使用JSON对象构建查询参数
  const queryParams = {};

  if (payload.lastId) {
    queryParams.lastId = payload.lastId;
  }

  if (payload.brandName) {
    queryParams.brandName = payload.brandName;
  }

  // 使用stringify将JSON对象转换为查询字符串
  const params = stringify(queryParams);
  const url = params ? `/mdc/shopAdd/user/brand/list?${params}` : '/mdc/shopAdd/user/brand/list';

  return format(request(url), errorHandler);
}

// 放弃举证
export async function submitGiveUpQuote(payload = {}, errorHandler) {
  const { body } = payload;
  return format(
    request('/mdc/auditTask/submitRefuse', {
      method: 'POST',
      body,
    }),
    errorHandler
  );
}
// 互斥类目查询
export async function searchMutexCateId(payload = {}) {
  const params = stringify(payload);
  return format(request(`/shops/isMutexCat?${params}`));
}

export async function preDuplicating(payload = {}) {
  return format(
    request('/mdc/shopAdd/preDupCheck', {
      method: 'POST',
      body: payload,
    }),
    null,
    { returnAllRes: true }
  );
}

//经纬度反解析城市
export async function fetchCityByLatLng(payload = {}) {
  //腾讯coordType=6
  const { latitude, longitude, coordType = 6 } = payload;
  const origin = window.location.origin;
  const protocol = window.location.protocol;
  let LatLnt_URL = '';
  if (origin.indexOf('test') > -1 || origin.indexOf('localhost') > -1) {
    LatLnt_URL = protocol + '//apollo.51ping.com';
  } else {
    LatLnt_URL = protocol + '//a.dper.com';
  }
  return format(
    request(
      LatLnt_URL +
        `/poi/sgc/gis/getCityByGeoInfo?lat=${Number(latitude)}&lng=${Number(
          longitude
        )}&coordType=${coordType}`
    )
  );
}

// 虚假门店创建
export async function submitCreateVirtualShop(payload = {}, errorHandler) {
  const origin = window.location.origin;
  return format(
    request(`${origin}/cc/create/virtualPoiNew`, {
      method: 'POST',
      body: {
        ...payload,
      },
    }),
    errorHandler
  );
}
// 虚拟门店业务类型
export async function getVirtualShopBusinessTypes(payload = {}, errorHandler) {
  const origin = window.location.origin;
  return format(
    request(`${origin}/cc/get/businessType`, {
      method: 'GET',
    }),
    errorHandler
  );
}

// 商户标签
export async function fetchShopTags(payload = {}) {
  const params = stringify(payload);
  return format(request(`/mdc/enrichInfo/queryShopTags?${params}`));
}
//标签商家可管理报错提交
export async function submitShopTags(payload = {}) {
  return request('/mdc/enrichInfo/saveShopTags', {
    method: 'POST',
    body: {
      ...payload,
    },
  });
}
export async function searchShopLogById(payload = {}) {
  const params = stringify(payload);
  return format(request(`/mdc/base/log?${params}`));
}

export function fetchZdcPermissionCheck() {
  return request('/permission/control/dzSaleVisitCrateShopLimit');
}

// 新增商户的初始化数据（目前有新增连锁）
export async function fetchInitShopInfo(payload = {}) {
  const params = stringify(payload);
  return format(request(`/mdc/shopAdd/init?${params}`));
}

export async function fetchShopActivityInfo(payload = {}) {
  const params = stringify(payload);
  return format(request(`/mdc/tags/getFestivalTag?${params}`), () => {}); //按照产品要求接口失败不提示信息（用户无感知），所以传递个空的error的function
}

export async function submitShopActivityInfo(payload = {}, returnAllRes) {
  return format(
    request('/mdc/tags/submitFestivalTag', {
      method: 'POST',
      body: {
        ...payload,
      },
    }),
    null,
    { returnAllRes }
  );
}

export async function submitBatchShopActivityInfo(payload = {}, returnAllRes) {
  return format(
    request('/mdc/tags/batchSubmitFestivalTag', {
      method: 'POST',
      body: {
        ...payload,
      },
    }),
    null,
    { returnAllRes }
  );
}

// 商场父子关系列表查询
export async function fetchBatchPaternity(payload = {}, errorHandler) {
  const params = stringify(payload);
  return format(request(`/mdc/paternity/batch?${params}`), errorHandler);
}

export async function fetchBatchRecords(payload = {}, errorHandler) {
  const params = stringify(payload);
  return format(request(`/mdc/shop/batch/records?${params}`));
}

export async function fetchBatchTemplate(payload = {}) {
  const params = stringify(payload);
  return format(request(`/mdc/shop/batch/templates?${params}`));
}

// 商场父子关系-批量上传
export async function submitBatchPaternity(payload = {}) {
  return format(
    request('/mdc/paternity/batch/submit', {
      method: 'POST',
      body: payload,
    }),
    null,
    { returnAllRes: true }
  );
}

export async function submitShopBatchPaternity(payload = {}) {
  return format(
    request('/mdc/shop/batch/submit', {
      method: 'POST',
      body: payload,
    }),
    null,
    { returnAllRes: true }
  );
}

// 查询补充举证-初始化配置
export async function fetchProofConfig(payload = {}) {
  return format(request(`/mdcMerchant/proof?${stringify(payload)}`), null, { returnAllRes: true });
}
// 查询补充举证-提交
export async function submitProofConfig(payload = {}) {
  return format(
    request('/mdcMerchant/proof/submit', {
      method: 'POST',
      body: payload,
    }),
    null,
    { returnAllRes: true }
  );
}

// 查询驳回原因
export async function fetchFeedbackInfo(payload = {}) {
  return format(request(`/mdcMerchant/feedback/info?${stringify(payload)}`), null, {
    returnAllRes: true,
  });
}

// 旧店情报采集相关
export async function fetchOldShopFeedbackInit(payload = {}) {
  return format(
    request('/mdc/feedback/oldShopCheck', {
      method: 'POST',
      body: payload,
    }),
    null,
    { returnAllRes: true }
  );
}
export async function fetchOldShopFeedback(payload = {}) {
  return format(
    request('/mdc/feedback/oldShop', {
      method: 'POST',
      body: payload,
    }),
    null,
    { returnAllRes: true }
  );
}

export function fetchShoplogDownload(payload = {}, errorHandler = null) {
  return format(
    request('/mdc/shop/batch/changes/download', { method: 'POST', body: payload }),
    errorHandler
  );
}

export function fetchShoplogDownloadStatus(payload = {}, errorHandler = null) {
  const { taskId, ...restPayload } = payload;
  return format(
    request(`/mdc/shop/batch/changes/download/${taskId}?${stringify(restPayload)}`),
    errorHandler
  );
}

export function fetchShoplogDownloadInit(errorHandler = null) {
  return format(request('/mdc/shop/batch/changes/init'), errorHandler);
}

export function fetchReportPageShoplog(payload = {}, errorHandler = null) {
  return format(request(`/mdc/shop/report/page/submitLog?${stringify(payload)}`), errorHandler);
}

export function fetchTemplatesAvailable(payload = {}, errorHandler = null) {
  return format(request(`/mdc/shop/batch/asynctemplates?${stringify(payload)}`), errorHandler);
}

export function fetchGenerateTemplate(payload = {}, errorHandler = null) {
  return format(
    request('/mdc/shop/batch/asynctemplates', {
      method: 'POST',
      body: payload,
    }),
    errorHandler,
    { returnAllRes: true }
  );
}
